import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=f722b25e&scoped=true"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"
import style0 from "./Branding.vue?vue&type=style&index=0&id=f722b25e&prod&lang=scss&scoped=true"
import style1 from "./Branding.vue?vue&type=style&index=1&id=f722b25e&prod&scoped=true&lang=css"
import style2 from "./Branding.vue?vue&type=style&index=2&id=f722b25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f722b25e",
  null
  
)

export default component.exports